// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._nd5l1sux{grid-area:1/1/2/3}._18u0v77o{margin-left:var(--ds-space-025,2px)}\n._19pkidpf{margin-top:0}\n._2hwxv77o{margin-right:var(--ds-space-025,2px)}\n._otyridpf{margin-bottom:0}\n._syaz131l{color:var(--ds-text-subtlest,#626f86)}\n._syaz1lh4{color:var(--ds-text-disabled,#091e424f)}", ""]);
// Exports
module.exports = exports;
